import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { PageHeader, Result, Button, Spin } from 'antd';
import { MyBreadcrumb, accessControls } from 'utils';
import TimeTrackerProjectForm from './form';

export default function TimeTrackerProjectUpdate() {
  const { id } = useParams();
  const history = useHistory();
  const [permissions, setPermissions] = useState(null);

  useEffect(() => {
    accessControls
      .fetch()
      .then(setPermissions)
      .catch(() => setPermissions({}));
  }, []);

  if (permissions == null) {
    return (
      <div style={{ padding: 24, textAlign: 'center' }}>
        <Spin size="large" />
      </div>
    );
  }
  if (!accessControls.can(permissions, 'TimeTrackerProject.update:any')) {
    return (
      <div style={{ padding: 24 }}>
        <Result
          status="403"
          title="Access denied"
          subTitle="You do not have permission to edit Time Tracker projects."
          extra={
            <Button type="primary" onClick={() => history.push('/')}>
              Go to Dashboard
            </Button>
          }
        />
      </div>
    );
  }

  return (
    <div>
      <MyBreadcrumb
        items={[
          { label: 'Home', path: '/' },
          { label: 'Time Tracker', path: '/time-tracker/tracker' },
          { label: 'Projects', path: '/time-tracker/projects' },
          { label: 'Update', path: '' },
        ]}
      />
      <PageHeader
        ghost={false}
        onBack={() => window.history.back()}
        title="Update Project"
        subTitle="Edit project details"
      >
        <TimeTrackerProjectForm id={id} />
      </PageHeader>
    </div>
  );
}
